
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

import { save } from '@/base/js/api'
let bjSrcg = require('@/assets/images/poster-bj.png')
export default {
name: 'app',
data() {
return {
slogan: [],
test: ['编辑'],
bj: bjSrcg,
sloganItem: '',
memberProductPostId: '',
paramData: '',
userInfo: '',
wxInfo: ''
}
},
components: {
PopupPicker
},
created() {

},
mounted() {












this.paramData = this.$route.params.posterInfo
if (undefined == this.paramData || null == this.paramData) {//用户刷新海报页面，则跳转到 产品页面
this.$router.push('product')
}

this.paramData.productPicUrl = this.paramData.productPicUrl.replace("http://", window.location.protocol + "//");
this._wxTool.auth();
this.wxInfo = this._wxTool.getUser();
this.userInfo = this._wxTool.getMember();

if (null == this.userInfo) {
console.log('need login');
this.$vux.toast.text('亲，生成海报前，必须先登陆哦', 'middle')
this.$router.push('login')
}

let sloganList = this.$route.params.posterInfo.recommendReason, recommendReasonList = []
sloganList.forEach(function (val) {
recommendReasonList.push(val.recommendReason)
})




this.slogan.push(recommendReasonList)
let param = this.$route.params.posterInfo
this.sloganItem = sloganList[0].recommendReason;
param.recommendReason = sloganList[0].recommendReason;
param.recommendReason = sloganList[0].recommendReason;

save(param).then(res => {
if (res.code == 0) {
console.log(res);

console.log(this.$url);
var qrUrl = `${this.$url}/productDetail/?productId=${this.paramData.productId}&posterId=${res.data.memberProductPostId}`


console.log(qrUrl)
var canvass = document.createElement("canvas");
this.qrcode.toCanvas(canvass, qrUrl, function (error) {
if (error) {
console.error(error)
return
}
console.log('success!');
})
this.data = res.data
this.memberProductPostId = res.data.memberProductPostId
var canvas2 = document.createElement("canvas");
let _canvas = document.querySelector('.por');
var w = parseInt(window.getComputedStyle(_canvas).width);
var h = parseInt(window.getComputedStyle(_canvas).height);

canvas2.width = w * 2;
canvas2.height = h * 2;
canvas2.style.width = w + "px";
canvas2.style.height = h + "px";
canvas2.style.display = 'none';



var context = canvas2.getContext("2d"), _this = this
context.scale(2, 2);
let dom = document.getElementById('qrcode');
console.log(dom);
canvass.style.width = 40 + "px";
canvass.style.height = 40 + "px";
dom.appendChild(canvass);
setTimeout(()=> {
this.html2canvas(document.querySelector('.por'), {useCORS: true, scale: 2, logging: false }).then(function (canvas) {
document.body.appendChild(canvas2);
_this.canvasImg = canvas.toDataURL("image/jpeg")

});//end of html2canvas
}, 1000)
} else {
this.$vux.toast.text(res.msg, 'middle')
}
})
},
methods: {
save() {
this.$vux.loading.show({
text: '生成中……'
})

let param = this.$route.params.posterInfo
param.recommendReason = this.sloganItem
param.memberProductPostId = this.memberProductPostId
param.base64Img = this.canvasImg

save(param).then(res => {
if (res.code == 0) {
this.$vux.loading.hide()
this.$vux.toast.text('生成的海报长按保存后就可以发送给朋友哦！！', 'middle')


this.data = res.data;


var wxTool_t = this._wxTool;
setTimeout(function () {
wxTool_t.previewImage(res.data.imgUrl);
}, 1000)
} else {
this.$vux.loading.hide();
this.$vux.toast.text(res.msg, 'middle');
}
})
},
onChange(val) {
console.log('val change', val)
this.$vux.loading.show({
text: '生成中……'
})
this.sloganItem = val[0]
var canvas2 = document.createElement("canvas");
var context = canvas2.getContext("2d"), _this = this
let _canvas = document.querySelector('.por');
var w = parseInt(window.getComputedStyle(_canvas).width);
var h = parseInt(window.getComputedStyle(_canvas).height);

canvas2.width = w * 2;
canvas2.height = h * 2;
canvas2.style.width = w + "px";
canvas2.style.height = h + "px";
canvas2.style.display = 'none';
setTimeout(()=> {
this.html2canvas(document.querySelector('.por'), {useCORS: true, scale: 2, logging: false }).then(function (canvas) {
document.body.appendChild(canvas2);
_this.canvasImg = canvas.toDataURL("image/jpeg")

_this.$vux.loading.hide()
});//end of html2canvas
})

},
}
}



// WEBPACK FOOTER //
// ./src/pages/poster/poster.vue